"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.provideStoreInstance = void 0;
var helpers_1 = require("./index");
function mappedComputed(cb) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return cb.apply({ $store: helpers_1.getStore() }, args);
    };
}
function provideStoreInstance(mapped) {
    var ret = {};
    for (var k in mapped) {
        ret[k] = mappedComputed(mapped[k]);
    }
    return ret;
}
exports.provideStoreInstance = provideStoreInstance;
